import { render, staticRenderFns } from "./adminAuthOwnerList.vue?vue&type=template&id=23f1fae8&scoped=true"
import script from "./adminAuthOwnerList.vue?vue&type=script&lang=js"
export * from "./adminAuthOwnerList.vue?vue&type=script&lang=js"
import style0 from "./adminAuthOwnerList.vue?vue&type=style&index=0&id=23f1fae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f1fae8",
  null
  
)

export default component.exports